import { PlayCircleOutline } from "@mui/icons-material";
import { Button, Dialog } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import useText from "../../hooks/useText";

const active = false;

const VideoPopoverTrigger = ({ src }: { src: string }) => {
    const [open, setOpen] = useState(false);
    const onClose = useCallback(() => setOpen(false), [setOpen]);
    const onOpen = useCallback(() => setOpen(true), [setOpen]);
    const videoRef = useRef<HTMLVideoElement>(null);
    const text = useText()?.videoPopoverTrigger;
    useEffect(() => {
        if (!videoRef.current) return;
        if (open) videoRef.current.play();
        else videoRef.current.pause();
    }, [open, videoRef]);
    return (
        <>
            <Dialog open={open} onClose={onClose} keepMounted>
                <video ref={videoRef} controls style={{ width: "100%" }}>
                    <source src={src} type="video/mp4" />
                </video>
            </Dialog>
            <Button
                variant="contained"
                size="small"
                color="primary"
                startIcon={<PlayCircleOutline />}
                onClick={onOpen}
            >
                {text.play}
            </Button>
        </>
    );
};

export default active ? VideoPopoverTrigger : () => null;